export default "__VITE_PUBLIC_ASSET__d82ee603__"